import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedList } from "../linkers/types";

function addTagToResource(httpClient: HttpClient) {
  return (tag: Tag, resourceId: Id) =>
    httpClient
      .sendHttpRequest<LinkedList>({
        endpoint: `/resources/${resourceId}`,
        method: HttpMethods.GET,
      })
      .then((resource) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/resources/${resourceId}`,
          method: HttpMethods.PATCH,
          data: { tags: [...resource.tags, tag.name] },
        }),
      );
}

export { addTagToResource };
